<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Page -->
        <template v-if="pageIsLoaded">
            <div class="row">
                <div class="col-xl-6">
                    <!-- Reload button -->
                    <b-button variant="light-success" class="col-12 gutter-b" @click="reloadAdmin">
                        <i class="fas fa-sync-alt"></i>
                        Reload analytics
                    </b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6">
                    <!-- NOTE - GRAPH: v4 / v5 usage -->
                    <div class="card card-custom gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="card-label">Version usage</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <apexchart
                                :options="chartVersionUsageOptions"
                                :series="chartVersionUsageSeries"
                                type="bar"
                                height="300px"
                            ></apexchart>
                            <!--end::Chart-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <!-- NOTE - GRAPH: Signups this month -->
                    <div class="card card-custom gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="card-label">Signups this month</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <apexchart
                                :options="chartMonthlySignupsOptions"
                                :series="chartMonthlySignupsSeries"
                                type="bar"
                                height="300px"
                            ></apexchart>
                            <!--end::Chart-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6">
                    <!-- NOTE - GRAPH: Userbase growth -->
                    <div class="card card-custom gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="card-label">User growth</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <!--begin::Chart-->
                            <apexchart
                                :options="chartUserGrowthOptions"
                                :series="chartUserGrowthSeries"
                                type="area"
                            ></apexchart>
                            <!--end::Chart-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <!-- NOTE - GRAPH: All-time searches -->
                    <div class="card card-custom gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="card-label">Daily Search Volume</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <!--begin::Chart-->
                            <apexchart
                                :options="chartSearchesDailyOptions"
                                :series="chartSearchesDailySeries"
                                type="area"
                            ></apexchart>
                            <!--end::Chart-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <pre>{{ dashboard }}</pre>
                </div>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import { mapGetters } from "vuex";
//    import ClipboardJS from "clipboard";
//    window.ClipboardJS = ClipboardJS;
import stringManagement from "@/mixins/stringManagement";

export default {
    name: "AdminPage",
    mixins: [stringManagement],
    components: {
        PagePreloader,
        CustomAlerts,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,

            // Displayers
            displayResults: false,

            // Error management
            errors: [],

            // Data
            dashboard: [],

            /**
             * SECTION - CHARTS
             */
            // NOTE - v4/v5 usage chart
            chartVersionUsageOptions: {},
            chartVersionUsageSeries: [],

            // NOTE - Monthly signups chart
            chartMonthlySignupsOptions: {},
            chartMonthlySignupsSeries: [],

            // NOTE - Chart daily searches
            chartSearchesDailyOptions: {},
            chartSearchesDailySeries: [],

            // NOTE - Chart user base growth
            chartUserGrowthOptions: {},
            chartUserGrowthSeries: [],
        };
    },

    methods: {
        reloadAdmin() {
            // Reset states
            this.pageIsLoaded = false;
            this.displayResults = false;
            this.getStatistics();
        },
        // First method here
        checkAdmin() {
            if (!this.isAdmin) {
                this.$router.push({
                    name: "dashboard",
                    params: {
                        propFlashMessages: [
                            {
                                type: "danger",
                                message: "You aren't authorized to access this area.",
                            },
                        ],
                    },
                });
            }
        },

        // Get all data from dashboard
        getStatistics() {
            axios
                .get("admin/statistics")
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Set data
                    this.dashboard = data.data;

                    // Prepare v4 / v5 chart
                    /**
                     * SECTION - Charts
                     */
                    // NOTE - Usage v4/v5 chart
                    var labels = [];
                    var seriesv4 = [];
                    var seriesv5 = [];
                    var seriesv5d1 = [];
                    var seriesv5d2 = [];
                    // Loop
                    data.data.usage.forEach((currentItem) => {
                        labels.push(currentItem.date);
                        seriesv4.push(currentItem.v4);
                        seriesv5.push(currentItem.v5);
                        seriesv5d1.push(currentItem.v5d1);
                        seriesv5d2.push(currentItem.v5d2);
                    });
                    // Set data
                    this.chartVersionUsageSeries = [
                        {
                            name: "Version 4",
                            data: seriesv4,
                            type: "bar",
                            stacked: true,
                        },
                        {
                            name: "Version 5",
                            data: seriesv5,
                            type: "bar",
                            stacked: true,
                        },
                        {
                            name: "Version 5.1",
                            data: seriesv5d1,
                            type: "bar",
                            stacked: true,
                        },
                        {
                            name: "Version 5.2",
                            data: seriesv5d2,
                            type: "bar",
                            stacked: true,
                        },
                    ];
                    this.chartVersionUsageOptions = {
                        chart: {
                            stacked: true,
                            toolbar: {
                                show: false,
                            },
                        },
                        grid: {
                            show: false,
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            show: true,
                            width: 2,
                            colors: ["transparent"],
                        },
                        legend: {
                            position: "right",
                            offsetY: 40,
                        },
                        xaxis: {
                            type: "datetime",
                            categories: labels,
                        },
                        yaxis: {
                            show: false,
                        },
                        fill: {
                            opacity: 1,
                        },
                        tooltip: {
                            shared: true,
                            y: {
                                formatter: function (val) {
                                    return val + " individual users";
                                },
                            },
                        },
                    };

                    // NOTE - Monthly signups chart
                    var labels = [];
                    var series = [];
                    // Loop
                    data.data.signups.forEach((currentItem) => {
                        labels.push(currentItem.niceDate);
                        series.push(currentItem.count);
                    });
                    // Set data
                    this.chartMonthlySignupsSeries = [
                        {
                            name: "Signups",
                            data: series,
                            type: "bar",
                        },
                    ];
                    this.chartMonthlySignupsOptions = {
                        chart: {
                            stacked: true,
                            toolbar: {
                                show: false,
                            },
                        },
                        grid: {
                            show: false,
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            show: true,
                            width: 2,
                            colors: ["transparent"],
                        },
                        legend: {
                            position: "right",
                            offsetY: 40,
                        },
                        xaxis: {
                            type: "datetime",
                            categories: labels,
                        },
                        yaxis: {
                            show: false,
                        },
                        fill: {
                            opacity: 1,
                        },
                        tooltip: {
                            shared: true,
                            y: {
                                formatter: function (val) {
                                    return val + " individual users";
                                },
                            },
                        },
                    };

                    // NOTE - User base growth
                    var labels = [];
                    var series = [];
                    // Loop
                    data.data.users.growth.forEach((currentItem) => {
                        series.push(currentItem.cumulative_growth);
                        // Hotfix
                        if (currentItem.date == "0000-00-00") {
                            console.log("Fixing date");
                            currentItem.date = "2018-03-01";
                        }
                        labels.push(currentItem.date);
                    });
                    // Set data
                    this.chartUserGrowthSeries = [
                        {
                            name: "Users",
                            data: series,
                        },
                    ];
                    this.chartUserGrowthOptions = {
                        chart: {
                            type: "area",
                            height: "auto",
                            zoom: {
                                enabled: false,
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            curve: "straight",
                        },
                        labels: labels,
                        xaxis: {
                            type: "datetime",
                        },
                        yaxis: {
                            opposite: true,
                        },
                        legend: {
                            horizontalAlign: "left",
                        },
                    };

                    // NOTE - Search volume chart
                    var labels = [];
                    var series = [];
                    // Loop
                    data.data.statistics.searches.forEach((currentItem) => {
                        series.push(currentItem.count);
                        labels.push(currentItem.date);
                    });
                    // Set data
                    this.chartSearchesDailySeries = [
                        {
                            name: "Search volume",
                            data: series,
                        },
                    ];
                    this.chartSearchesDailyOptions = {
                        chart: {
                            type: "area",
                            height: "auto",
                            zoom: {
                                enabled: false,
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            curve: "straight",
                        },
                        labels: labels,
                        xaxis: {
                            type: "datetime",
                        },
                        yaxis: {
                            opposite: true,
                        },
                        legend: {
                            horizontalAlign: "left",
                        },
                    };
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    // Shut off preloader
                    this.pageIsLoaded = true;

                    // Add display
                    this.displayResults = true;
                });
        },
    },

    mounted() {
        // Check if we're admin
        this.checkAdmin();

        // Get admin data
        this.getStatistics();

        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Admin", route: "admin" },
            { title: "Statistics", route: "admin-statistics" },
        ]);
    },

    computed: {
        ...mapGetters({ currentUser: "auth/currentUser", isAdmin: "auth/isAdmin" }),
    },
};
</script>
